import React from 'react';
import PropTypes from 'prop-types';
import IconButton from "../material/IconButton";
import OverlayController from "../overlay/OverlayController";
import TransitionEventDialog from "./TransitionEventDialog";
import _ from 'lodash';

export default class TransitionEventsPanel extends React.Component {

    static propTypes = {
        project: PropTypes.object.isRequired,
        delegate: PropTypes.shape({
            transitionEventsPanelDidCreateTransitionEvent: PropTypes.func.isRequired,
            transitionEventsPanelDidUpdateTransitionEvent: PropTypes.func.isRequired,
            transitionEventsPanelDidDeleteTransitionEvent: PropTypes.func.isRequired
        }).isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    onEditTransitionEventClick = (event) => {
        let transitionEventId = event.currentTarget.dataset.transitionEventId;
        let transitionEvent = _.find(this.props.project.transitionEvents, {id: transitionEventId});
        OverlayController.showOverlay({
            component: <TransitionEventDialog project={this.props.project} transitionEvent={transitionEvent} delegate={this.props.delegate}/>
        });
    };

    onCreateTransitionEventClick = () => {
        OverlayController.showOverlay({
            component: <TransitionEventDialog project={this.props.project} delegate={this.props.delegate}/>
        });
    };

    renderTransitionEvents() {
        let transitionEvents = this.props.project.transitionEvents.map(transitionEvent => {
            return (
                <li key={transitionEvent.id} className="materialListItem singleLine">
                    <div className="materialListItemText">{transitionEvent.name}</div>
                    <div className="materialListItemRightIcon">
                        <IconButton
                            buttonProps={{
                                "data-transition-event-id": transitionEvent.id
                            }}
                            icon={<i className="fa fa-sliders"/>}
                            buttonSize={IconButton.ButtonSize.buttonSize40}
                            iconFontSize={IconButton.IconFontSize.iconFontSize18}
                            onClick={this.onEditTransitionEventClick}
                        />
                    </div>
                </li>
            );
        });

        // Prepend a "create transition event" item
        transitionEvents.unshift(
            <li key="createTransitionEvent" className="materialListItem singleLine" onClick={this.onCreateTransitionEventClick}>
                <div className="materialListItemText">Create Transition Event</div>
                <div className="materialListItemRightIcon">
                    <IconButton
                        icon={<i className="fa fa-plus"/>}
                        buttonSize={IconButton.ButtonSize.buttonSize40}
                        iconFontSize={IconButton.IconFontSize.iconFontSize18}
                    />
                </div>
            </li>
        );

        return <ul className="materialList transitionEventsPanelList">{transitionEvents}</ul>;
    }

    render() {
        return (
            <div className="transitionEventsPanel">
                {this.renderTransitionEvents()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/diagram/TransitionEventsPanel.js